<template>
<div class="ChecklistStatusDialogColorPicker">
  <div v-for="(color, i) in customStatusesColors"
       :key="`color-${i}`"
       class="ChecklistStatusDialogColorPicker__item clickable"
       :class="{'ChecklistStatusDialogColorPicker__item--active': modelValue === color}"
       :style="{backgroundColor: color}"
       @click="$emit('update:modelValue', color)"
  >
    <app-material-icon
      v-if="modelValue === color"
      name="check"
      size="sm"
      class="text-icon-inverted"

    />
  </div>
</div>
</template>

<script>
import { customStatusesColors } from '@/project/checklist/dialogs/taskStatus'

export default {
  name: 'ChecklistStatusDialogColorPicker',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      customStatusesColors,
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.ChecklistStatusDialogColorPicker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin: 4px;
    @include border-radius('border-radius-2');
    &--active {
      box-shadow: 0 0 0 3px rgb(var(--v-theme-sky-400)),inset 0 0 0 1px white; // focus-ring
    }
  }
}
</style>
